import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | [string, string, string[] | string][] | null
> => {
  return {
    segmentation_fields: params.segments ?? [],
    aggregate_field: params.measure ?? "forecast",
    filters: params.filters,
    post_filters: params.postFilters ?? [],
  };
};
